import { render } from "./SubmissionSuccess.vue?vue&type=template&id=3a05de69&scoped=true"
import script from "./SubmissionSuccess.vue?vue&type=script&lang=js"
export * from "./SubmissionSuccess.vue?vue&type=script&lang=js"

import "./SubmissionSuccess.vue?vue&type=style&index=0&id=3a05de69&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a05de69"]])

export default __exports__